// The patient's out-of-pocket for a plan — the number every payment option is priced against.
//
// Extracted 2026-08-06 because this sum had been written out by hand in THREE places
// (PlanFinancialSummary.vue, TxPresenterPresentMode.vue, TxPatientView.vue) and was needed in
// a fourth (TxPresenterBuilder.vue, which had no copy at all and therefore no way to know what
// amount to ask Cherry to price). Four copies of a money calculation is three too many; the
// same lesson is already recorded above canTakeDownpayment() in paymentOptions.js, where a
// hand-copied predicate drifted and broke financing in production on 2026-08-04.
//
// KEEP IN SYNC with tx-presenter-service/lib/pdf/components/PaymentOptionsBlock.js and
// PlanSummaryBlock.js, which compute the same sum for the signed PDF.

/**
 * Σ procedures[].patientFee, plus the guarantor balance when the office has that layer on.
 *
 * `balanceAmount` is signed: positive = the family owes it (adds to what they pay today),
 * negative = a credit (reduces it). Callers pass 0 — or simply omit it — when the balance
 * layer is off, which is why it is not read from a setting here: whether to include it is a
 * display decision each surface already resolves.
 */
export function patientPortion(procedures, balanceAmount) {
  const procs = Array.isArray(procedures) ? procedures : [];
  const sum = procs.reduce((s, p) => s + (parseFloat(p && p.patientFee) || 0), 0);
  return sum + (parseFloat(balanceAmount) || 0);
}

export default patientPortion;
